module.exports = __webpack_public_path__ + "media/images/smile-282638af78af017c32e37b8cb54e705c.png";